import { render, staticRenderFns } from "./MortgageEditor.vue?vue&type=template&id=18545bf8"
import script from "./MortgageEditor.vue?vue&type=script&lang=js"
export * from "./MortgageEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports